import { apiGetOrganisation } from '@/api/organisation';
import localforage from 'localforage';
import { logger } from '@/utils/screenEventsLogger';

const ORGANISATION_CACHE_KEY = 'cached_organisation_data';

const DEFAULT_TENANT_CONFIG = {
  caps: false,
  floorNameType: 'vaning',
  reverseSort: false,
  separator: ', ',
};

const DEFAULT_ORGANISATION = {
  TenantIntegration: DEFAULT_TENANT_CONFIG,
};

const state = {
  organisation: DEFAULT_ORGANISATION,
  lastFetchTime: null,
};

const getters = {
  getOrganisation: (state) => state.organisation,
  isOrganisationLoaded: (state) => state.lastFetchTime !== null,
  getTenantIntegrationConfig: (state) => {
    if (state.organisation && state.organisation.TenantIntegration) {
      return state.organisation.TenantIntegration;
    }
    return DEFAULT_TENANT_CONFIG;
  },
  useSyncTenantsWidget: (state) => {
    const organisation = state.organisation;
    const hasTenantsIntegration = organisation?.sync?.integrations?.some(
      (sync) => sync.type === 'tenants',
    );

    return organisation?.enable_sync && hasTenantsIntegration;
  },
  getSyncTenantsConfig: (state) => {
    const hasTenantsIntegration = state.organisation?.sync?.integrations?.find(
      (sync) => sync.type === 'tenants',
    );

    return hasTenantsIntegration?.config;
  },
};

const mutations = {
  SET_ORGANISATION(state, organisation) {
    state.organisation = organisation;
    state.lastFetchTime = Date.now();
  },
  SET_TENANT_INTEGRATION(state, tenantIntegration) {
    if (state.organisation) {
      state.organisation.TenantIntegration = tenantIntegration;
    }
  },
};

const actions = {
  async fetchOrganisation({ commit, state, rootState }) {
    try {
      const response = await apiGetOrganisation();

      if (response && response.data) {
        commit('SET_ORGANISATION', response.data);

        try {
          await localforage.setItem(ORGANISATION_CACHE_KEY, response.data);
        } catch (cacheError) {
          logger.addLog(`Error caching organisation data: ${cacheError.message}`);
        }
      }

      return state.organisation;
    } catch (error) {
      logger.addLog(`Error fetching organisation: ${error.message}`);

      const cachedData = await localforage.getItem(ORGANISATION_CACHE_KEY);
      if (cachedData) {
        commit('SET_ORGANISATION', cachedData);
      }

      return state.organisation;
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
